<template>
<div class="chapter">
<div class="inner_page">
<h2 class="nobreak" id="pgepubid00003">THE HOUSE ON THE CLIFF</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section002_split_001.vue?1b6e5d2f